import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import Image from '@/common/Image';

export const CarouselImage = createComponent(Image, {
  className: 'shrink-0 overflow-hidden rounded-md object-cover',
  wrapperClassName: cx(
    'aspect-[3/2]',
    // Show 2 plus 1/3 of the 3rd image
    // Subtract the left padding of the 3 visible images before dividing
    'min-w-[calc((100vw-(3*var(--spacing-2xl)))/2.33)]',
    // At a larger viewport we do the same but show 3 and 1/3 images
    'min-[576px]:min-w-[calc((100vw-(4*var(--spacing-2xl)))/3.33)]',
    'sm:min-w-[161px]'
  )
});
